import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";

export function getSPD(
  selectedSpdrId: number | undefined,
  ftlRoutes: Array<FtlRouteViewModel> | undefined
) {
  if (!selectedSpdrId || !ftlRoutes) {
    return {
      supplier: undefined,
      plant: undefined,
      dock: undefined,
    };
  }

  const oneRouteWithSpdr = ftlRoutes.find((r) =>
    r.SpdrsOnThisRoute?.find((s) => s.SpdrId === selectedSpdrId)
  );

  if (!oneRouteWithSpdr) {
    return {
      supplier: undefined,
      plant: undefined,
      dock: undefined,
    };
  }

  const theSpdr = oneRouteWithSpdr.SpdrsOnThisRoute?.find(
    (s) => s.SpdrId === selectedSpdrId
  );

  if (!theSpdr) {
    return {
      supplier: undefined,
      plant: undefined,
      dock: undefined,
    };
  }

  return {
    supplier: theSpdr.SupplierGsdb,
    plant: theSpdr.PlantGsdb,
    dock: theSpdr.DockCode,
  };
}
